const ScssData = {
  description: ["A list of all the configurable SCSS variables, SCSS mixins & SCSS maps included in the core Roseworx framework import."]
}

export default ScssData;